<template>
  <div class="eventInfo-wrapper" v-if="task">
    <div class="form-container">
      <div class="form">
        <div class="title">{{ task.subject.code }} {{ task.name }}</div>

        <TaskTimeLine
          ref="taskTimeLines"
          :taskData="task"
          :statusList="statusList"
        />

        <div class="infos">
          <table class="infos-table" width="100%">
            <tr>
              <td class="label">
                状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：
              </td>
              <td>
                <TaskStatus :status="task.status" />
              </td>
            </tr>
            <tr>
              <td class="label">
                描&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;述：
              </td>
              <td>{{ task.comment }}</td>
            </tr>
            <tr>
              <td class="label">
                备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：
              </td>
              <td>{{ task.note }}</td>
            </tr>
            <tr>
              <td class="label">调&nbsp;&nbsp;查&nbsp;&nbsp;员：</td>
              <td v-if="task.surveyor">{{ task.surveyor.name }}</td>
              <td v-else>-</td>
            </tr>
            <tr>
              <td class="label">测评规则：</td>
              <td v-if="task.evaluation_form">
                《{{ task.evaluation_form.name }}》
              </td>
              <td v-else>-</td>
            </tr>
            <tr>
              <td class="label">申诉截止：</td>
              <td v-if="task.appeal_end_at">{{ task.appeal_end_at }}</td>
              <td v-else>-</td>
            </tr>
            <tr>
              <td class="label">测评得分：</td>
              <td v-if="task.evaluation_form">
                {{
                  task.evaluation_form.init_score +
                  (pointScore >= 0 ? " + " : " - ") +
                  Math.abs(pointScore)
                }}
                = {{ task.evaluation_form.init_score + pointScore }} 分
              </td>
              <td v-else>-</td>
            </tr>
          </table>
        </div>

        <el-tabs type="card" v-model="activeTab" v-loading="loading">
          <el-tab-pane label="按题目看" name="rule">
            <template v-if="rules.length">
              <evaluation-rule
                v-for="(item, index) in rules"
                :rule="item"
                :key="item.id"
                :index="index"
                :points="points"
                type="look"
                @upDataActions="getEvaluationRuleForm"
              ></evaluation-rule>
            </template>
            <template v-else>
              <div class="empyt-data">暂无数据</div>
            </template>
          </el-tab-pane>
          <!-- <el-tab-pane lazy label="按地图看" name="map">
            <PathMap></PathMap>
          </el-tab-pane> -->
          <el-tab-pane label="按点位看" name="appealed">
            <div class="points" v-if="points.length">
              <PointCard
                v-for="point in points"
                :key="point.id"
                :point="point"
                :rule="point.evaluation_rule"
                @upDataActions="getEvaluationRuleForm"
              ></PointCard>
            </div>
            <template v-else>
              <div class="empyt-data">暂无数据</div>
            </template>
          </el-tab-pane>
          <el-tab-pane label="按地图查看" name="map">
            <div class="points" v-if="points.length">
              <PathMap :points="points"></PathMap>
            </div>
            <template v-else>
              <div class="empytData">暂无数据</div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="right">
      <div v-if="isSelf">
        <div class="title">图片编辑</div>
        <div class="editImage" style="margin: 20px 0">
          <el-button type="primary" @click="handleImage('add')"
            >添加图片</el-button
          >
        </div>
      </div>
      <template
        v-if="
          task.status === 'uploaded' ||
          task.status === 'confirmed' ||
          task.status === 'appealing' ||
          task.status === 'appealed' ||
          task.status === 'reviewed'
        "
      >
        <div class="title">审核操作</div>
        <div class="buttons">
          <el-input
            v-model="message"
            style="margin-bottom: 10px"
            placeholder="请输入审核备注"
          ></el-input>
          <el-button
            type="primary"
            @click="upDataTaskActions('confirm')"
            v-if="task.status === 'uploaded'"
            >审核通过</el-button
          >
          <el-button
            type="danger"
            @click="upDataTaskActions('reject')"
            v-if="task.status === 'uploaded'"
            >驳回重测</el-button
          >
          <el-button
            type="primary"
            @click="upDataTaskActions('appealing')"
            v-if="task.status === 'confirmed'"
            >开启申诉期</el-button
          >
          <el-button
            type="primary"
            v-if="task.status === 'reviewed' && isAfterAppeal"
            @click="upDataTaskActions('complete')"
            >任务完结</el-button
          >
        </div>
      </template>

      <div class="title">操作记录</div>
      <div class="actions">
        <template v-if="task.actions.length">
          <div class="action" v-for="action in task.actions" :key="action.id">
            <div class="head">
              <div class="doer">
                <i class="icon el-icon-user-solid"></i>
                {{ action.doer.name }}
              </div>
              <div class="created_at">{{ action.created_at }}</div>
            </div>
            <div class="content">
              {{ action.content ? action.content : "无" }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="empyt-data">暂无数据</div>
        </template>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%">
      <el-form
        :model="form"
        ref="numberValidateForm"
        label-width="80px"
        class="demo-ruleForm"
        :rules="rule"
        v-if="dialogVisible"
      >
        <el-form-item label="地址" prop="poi" v-if="imageType === 'add'">
          <el-input type="text" v-model="form.poi" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="latitude" v-if="imageType === 'add'">
          <el-input
            type="number"
            v-model="form.latitude"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="longitude" v-if="imageType === 'add'">
          <el-input
            type="number"
            v-model="form.longitude"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择图片" v-if="imageType === 'add'">
          <uploadFile
            scene="points"
            @uploadSuccess="uploadData"
            @uploadRemove="removeFiles"
          />
        </el-form-item>
        <el-form-item label="新的分数" prop="score" v-if="imageType === 'edit'">
          <el-input type="number" v-model="form.score" size="mini"></el-input>
        </el-form-item>
        <el-form-item
          label="选择图片"
          v-if="imageType === 'edit'"
          prop="pointId"
        >
          <el-select placeholder="请选择" v-model="form.pointId">
            <el-option
              v-for="item in points"
              :key="item.id"
              :label="item.poi"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="放到" prop="evaluation_rule_id">
          <el-cascader
            v-model="form.evaluation_rule_id"
            :options="rules"
            :props="defaultProps"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cencal">取 消</el-button>
        <el-button type="primary" @click="handleSend">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EvaluationRule from "./evaluation-rule.vue";
import {
  taskEventPoints,
  getTaskInfo,
  upDataTaskActions,
  createPoints,
  editPoints,
} from "@/api/project";
import { getEvaluationRuleTree } from "@/api/evaluation-rule";
import moment from "moment";
import PathMap from "./path-map";
import TaskStatus from "./task-status";
import TaskTimeLine from "./task-time-line";
import PointCard from "./point-card";
import uploadFile from "../../street/components/upload-file.vue";

export default {
  provide() {
    return {
      taskDetail: this.taskDetail,
    };
  },
  data() {
    return {
      taskDetail: { taskInfo: null },
      task: null,
      message: "",
      statusList: [
        {
          value: "created",
          label: "未开始",
        },
        {
          value: "started",
          label: "进行中",
        },
        {
          value: "ended",
          label: "已测评",
        },
        {
          value: "uploaded",
          label: "已上传",
        },
        {
          value: "confirmed",
          label: "已初审",
        },
        {
          value: "appealing",
          label: "申诉中",
        },
        {
          value: "appealed",
          label: "已申诉",
        },
        {
          value: "reviewing",
          label: "复核中",
        },
        {
          value: "reviewed",
          label: "已复核",
        },
        {
          value: "completed",
          label: "已完结",
        },
      ],
      activeTab: "rule",
      points: [],
      rules: [],
      title: "",
      loading: false,

      ////
      form: {
        poi: "",
        latitude: "",
        longitude: "",
        evaluation_rule_id: [],
        pointId: "",
      },
      rule: {
        poi: [{ required: true, message: "请输入地址名称", trigger: "blur" }],
        latitude: [{ required: true, message: "请输入纬度", trigger: "blur" }],
        longitude: [{ required: true, message: "请输入经度", trigger: "blur" }],
        evaluation_rule_id: [
          { required: true, message: "请选择新的规则", trigger: "blur" },
        ],
        pointId: [{ required: true, message: "请选择测评点", trigger: "blur" }],
        score: [{ required: true, message: "请填写分数", trigger: "blur" }],
      },

      //
      fileListKey: [],
      dialogVisible: false,
      imageType: "",
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
        // multiple: true,
      },
    };
  },
  computed: {
    isSelf() {
      // return this.$store.getters.role === "owner"
      return this.$store.getters.isOwner;
    },
    pointScore() {
      return this.points.reduce((total, item) => {
        return total + item.score;
      }, 0);
    },

    // 已过申诉期
    isAfterAppeal() {
      const appealEndAt = moment(this.task.appeal_end_at);
      if (!appealEndAt.isValid()) {
        return false;
      }
      return moment().isAfter(appealEndAt); // 过申诉截止时间
    },
  },
  components: {
    EvaluationRule,
    PathMap,
    TaskTimeLine,
    // PathMap,
    PointCard,
    TaskStatus,
    uploadFile,
  },
  mounted() {
    this.getEvaluationRuleForm();
  },
  created() {
    // 查询一次 proprietor 信息用于确定是否还特殊账号
    this.$store.dispatch("getProprietor");
  },
  methods: {
    cencal() {
      this.dialogVisible = false;
      this.fileListKey = [];
      this.form = {
        poi: "",
        latitude: "",
        longitude: "",
        evaluation_rule_id: [],
        pointId: "",
      };
    },
    handleSend() {
      this.$refs["numberValidateForm"].validate((valid) => {
        if (valid) {
          if (this.imageType === "edit") {
            this.editPoints();
          } else {
            this.createPoints();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editPoints() {
      let evaluation_rule_id =
        this.form.evaluation_rule_id[this.form.evaluation_rule_id.length - 1];
      editPoints(this.form.pointId, {
        evaluation_rule_id,
        score: this.form.score,
      }).then((res) => {
        this.$message({ type: "success", message: "修改成功" });
        this.getPointInfo();
        this.cencal();
      });
    },
    createPoints() {
      let task_id = this.$route.params.taskId;
      let evaluation_rule_id =
        this.form.evaluation_rule_id[this.form.evaluation_rule_id.length - 1];
      createPoints({
        type: "image",
        uri: this.fileListKey.toString(),
        poi: this.form.poi,
        latitude: this.form.latitude,
        longitude: this.form.longitude,
        evaluation_rule_id,
        task_id,
      }).then((res) => {
        this.$message({ type: "success", message: "创建成功" });
        this.getPointInfo();
        this.cencal();
      });
    },
    removeFiles(index) {
      this.fileListKey.splice(index, 1);
      // console.log(this.fileListKey);
    },
    uploadData({ key }) {
      this.fileListKey.push(key);
    },
    handleImage(data) {
      this.title = data == "edit" ? "修改测评点" : "创建测评点";
      this.dialogVisible = true;
      this.imageType = data;
    },
    upDataTaskActions(action) {
      if (action == "reject" && !this.message.length) {
        this.$message({ type: "error", message: "拒绝申诉必须填写拒绝原因" });
        return;
      }
      let id = this.$route.params.taskId;
      upDataTaskActions({ action, message: this.message, id }).then((res) => {
        this.getEvaluationRuleForm();
        this.$forceUpdate();
        this.$message({ type: "success", message: "提交成功" });
      });
    },

    getEvaluationRuleForm(val) {
      let id = this.$route.params.taskId;
      getTaskInfo({ id }).then((res) => {
        // 赋值，不改变对象地址
        this.task = res.data;
        this.taskDetail.taskInfo = res.data;
        this.$nextTick(() => {
          this.$refs.taskTimeLines && this.$refs.taskTimeLines.computedActive();
        });
        this.getPointInfo();
        this.getTrees();
      });
    },
    getTrees() {
      let evaluation_form_id = this.task.evaluation_form_id;
      getEvaluationRuleTree({ evaluation_form_id }).then((res) => {
        this.rules = res.data;
      });
    },
    getPointInfo() {
      this.loading = true;
      let task_id = this.$route.params.taskId;
      taskEventPoints({ task_id })
        .then((res) => {
          this.points = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.eventInfo-wrapper {
  display: flex;
  flex-direction: row;
  width: 1410px;
  background-color: white;
  margin: 0 auto;
}

.form-container {
  height: calc(100vh - 84px);
  overflow-y: auto;
  flex: 1;
  margin-left: 10px;
}

.form {
  border: 1px solid #e1e6f0;
  padding: 30px;

  .comment {
    padding: 10px 0;
    color: gray;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }

  .steps {
    margin: 20px 0;
  }

  .infos {
    padding-bottom: 20px;
    margin-bottom: 20px;
    // border-bottom: 1px solid #ccc;
  }

  .infos-table {
    // border: 1px solid #ccc;
    td {
      padding: 3px;
    }

    .label {
      text-align: left;
      width: 100px;
    }
  }
}

.points {
  display: flex;
  flex-wrap: wrap;
}

.right {
  width: 400px;
  height: calc(100vh - 104px);
  border: 1px solid #e1e6f0;
  margin-left: 10px;
  padding: 20px;
  overflow-y: scroll;

  .buttons {
    margin: 20px 0;
  }

  .title {
    font-weight: bold;
    font-size: 14px;
  }

  .actions {
    // max-height: 650px;
    // overflow-y: scroll;
    .action {
      // border-bottom: 1px solid #ccc;
      padding: 5px 0;

      .head {
        display: flex;
        justify-content: space-between;

        .doer {
          color: #333;
        }

        .created_at {
          font-size: 12px;
          color: #999;
        }
      }

      .content {
        margin: 5px 0;
        background-color: #f9f9f9;
        padding: 5px 10px;
        border-radius: 5px;
        color: #3d3d3d;
      }
    }
  }
}

.empyt-data {
  // position: absolute;
  min-height: 60px;
  text-align: center;
  width: 100%;
  height: 100%;
  min-height: 378px;
  font-size: 14px;
  line-height: 378px;
  color: #909399;
  // transform: translate(-50%, -50%);
}
</style>
